import $ from 'jquery';

/**
 * * @returns {void}
 */
const backToTopInit = () => {
    const backToTopButton = document.querySelector('.js-back-to-top');

    if (!backToTopButton) {
        return;
    }

    backToTopButton.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    });
};

// doc ready
$(() => {
    backToTopInit();
});
